import { workspace } from '../../shared/api';

export const TrackerEventService = {
  async track(prescriptionId: number, eventName: string, eventBody?: Record<string, any>) {
    await workspace.post(`/prescricao/${prescriptionId}/evento`, {
      eventName,
      eventBody,
    });
  },
};
